export default __webpack_public_path__ + "static/media/Luminor.8774c43e.svg";